var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"flex wrap"},[_c('div',{staticClass:"fill"},[_c('h2',[_vm._v("Open Auctions")]),_vm._l((_vm.bids),function(bidtype,bidtypekey){return _c('div',{key:bidtypekey},[(Object.keys(bidtype).length > 0)?_c('h3',[_vm._v(_vm._s(bidtypekey))]):_vm._e(),_vm._l((bidtype),function(bid,bidkey){return _c('div',{key:bidkey,staticClass:"container p8"},[(_vm.$store.state.items[bidtypekey][bidkey])?_c('div',[(
              +bid >=
              +Object.keys(_vm.$store.state.items[bidtypekey][bidkey].bids).sort(
                (a, b) => +b - +a
              )[0]
            )?_c('div',{staticClass:"success"},[_vm._v(" Winning ")]):_c('div',{staticClass:"warn flex wrap align-center between p4"},[_vm._v(" Losing "),(!_vm.increasebid[bidkey])?_c('button',{staticClass:"xs-font",attrs:{"type":"button"},on:{"click":function($event){_vm.$set(
                  _vm.increasebid,
                  bidkey,
                  +Object.keys(
                    _vm.$store.state.items[bidtypekey][bidkey].bids
                  ).sort((a, b) => +b - +a)[0] + 1
                )}}},[_c('i',{staticClass:"fa fa-arrow-up r4"}),_vm._v(" bid ")]):_vm._e(),(_vm.increasebid[bidkey])?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.increasebid[bidkey]),expression:"increasebid[bidkey]"}],attrs:{"type":"number","min":+Object.keys(
                  _vm.$store.state.items[bidtypekey][bidkey].bids
                ).sort((a, b) => +b - +a)[0] + 1},domProps:{"value":(_vm.increasebid[bidkey])},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.increasebid, bidkey, $event.target.value)}}}):_vm._e(),(_vm.increasebid[bidkey])?_c('button',{staticClass:"xs-font",attrs:{"type":"button"},on:{"click":function($event){_vm.loading = true;
                _vm.$store
                  .dispatch('util', {
                    type: 'hash',
                    body: _vm.$store.state.auth.uid,
                  })
                  .then((h) => {
                    _vm.$set(
                      _vm.$store.state.items[bidtypekey][bidkey].bids,
                      _vm.increasebid[bidkey],
                      h
                    );
                    _vm.$store
                      .dispatch('update', {
                        id: bidkey,
                        type: bidtypekey,
                        data: _vm.$store.state.items[bidtypekey][bidkey],
                      })
                      .then(() => {
                        _vm.$store.state.user[_vm.$store.state.auth.uid].auctions[
                          bidtypekey + '_' + bidkey
                        ] = _vm.increasebid[bidkey];
                        _vm.$store
                          .dispatch('update', {
                            type: 'user',
                            id: _vm.$store.state.auth.uid,
                            data: _vm.$store.state.user[_vm.$store.state.auth.uid],
                          })
                          .then(() => {
                            _vm.$set(
                              _vm.bids[bidtypekey],
                              bidtype,
                              _vm.increasebid[bidkey]
                            );
                            _vm.increasebid[bidkey] = false;
                            _vm.$store
                              .dispatch('query', {
                                type: 'item',
                                collection: bidtypekey,
                                id: bidkey,
                              })
                              .then(
                                () =>
                                  _vm.$set(
                                    _vm.$store.state.counts,
                                    'auctions',
                                    _vm.$store.state.counts.auctions + 1
                                  ),
                                (_vm.loading = false)
                              );
                          });
                      });
                  });}}},[_vm._v(" Commit Bid ")]):_vm._e()]),_c('router-link',{attrs:{"to":`/i/${bidtypekey}/${bidkey}`}},[_vm._v(_vm._s(_vm.$store.state.items[bidtypekey][bidkey].basics.title))]),_c('div',[_vm._v(" Ending "),_c('itime',{attrs:{"timestamp":_vm.$store.state.items[bidtypekey][bidkey].purchases[
                  'auction end'
                ]}})],1),_c('div',{class:+bid >=
              +Object.keys(_vm.$store.state.items[bidtypekey][bidkey].bids).sort(
                (a, b) => +b - +a
              )[0]
                ? 'success-text'
                : 'warn-text'},[_vm._v(" Your Bid "+_vm._s(Intl.NumberFormat("us-US", { style: "currency", currency: "USD", }).format(bid))+" ")]),_c('div',[_vm._v(" High Bid "+_vm._s(Intl.NumberFormat("us-US", { style: "currency", currency: "USD", }).format( Object.keys(_vm.$store.state.items[bidtypekey][bidkey].bids).sort( (a, b) => +b - +a )[0] ))+" ")])],1):_vm._e()])})],2)})],2),_c('div',{staticClass:"fill"},[_c('h2',[_vm._v("Closed Auctions")]),_vm._l((_vm.over),function(overtype,overtypekey){return _c('div',{key:'over' + overtypekey},[_c('h3',[_vm._v(_vm._s(overtypekey))]),_vm._l((overtype),function(overbid,overbidkey){return _c('div',{key:overbidkey,staticClass:"container p8"},[(_vm.$store.state.items[overtypekey][overbidkey])?_c('div',[(
              typeof overbid !== 'number' ||
              +overbid >=
                +Object.keys(
                  _vm.$store.state.items[overtypekey][overbidkey].bids
                ).sort((a, b) => +b - +a)[0]
            )?_c('div',{staticClass:"success flex between align-center p4"},[_vm._v(" Won "),(
                !_vm.$store.state.items[overtypekey][overbidkey].purchases[
                  'auction complete'
                ]
              )?_c('span',[_vm._v(" Your Bid "),_c('span',[_vm._v(" "+_vm._s(Intl.NumberFormat("us-US", { style: "currency", currency: "USD", }).format(overbid))+" ")]),(!_vm.increasebid[overbidkey])?_c('button',{staticClass:"xs-font",attrs:{"type":"button"},on:{"click":function($event){_vm.$set(
                    _vm.$store.state.items[overtypekey][overbidkey].purchases,
                    'cost',
                    +overbid
                  );
                  _vm.addToCart(_vm.$store.state.items[overtypekey][overbidkey], 1);}}},[_c('i',{staticClass:"fa fa-handshake r4"}),_vm._v(" Complete Transaction ")]):_vm._e()]):_c('router-link',{attrs:{"to":`/orders/${_vm.$store.state.items[overtypekey][overbidkey].purchases['auction complete']}`}},[_vm._v("Paid, Order: "+_vm._s(_vm.$store.state.items[overtypekey][overbidkey].purchases[ "auction complete" ]))])],1):_c('div',{staticClass:"warn flex wrap align-center between p4"},[_vm._v(" Lost ")]),_c('router-link',{attrs:{"to":`/i/${overtypekey}/${overbidkey}`}},[_vm._v(_vm._s(_vm.$store.state.items[overtypekey][overbidkey].basics.title))]),_c('div',[_vm._v(" Ended "),_c('itime',{attrs:{"timestamp":_vm.$store.state.items[overtypekey][overbidkey].purchases[
                  'auction end'
                ]}})],1)],1):_vm._e()])})],2)})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }